import BenefitQuotesServices from './BenefitQuotesServices';
import BenefitQuotesServicesMock from './BenefitQuotesServicesMock';

const isMockingService = process.env.VUE_APP_MOCKING_SERVICES === 'true' || process.env.VUE_APP_MOCKING_SERVICES === true;
export default isMockingService ? BenefitQuotesServicesMock : BenefitQuotesServices;
